import { useCallback, useState } from 'react';

import { sessionStorageCache } from '../utils';

export const useSessionStorageState = <T>(initialValue: T, key: string): [T, (data: T) => void] => {
	const [state, setState] = useState<T>(() => sessionStorageCache.get(key) ?? initialValue);

	const setStateCallback = useCallback(
		(data: T): void => {
			setState(data);
			sessionStorageCache.set(key, data);
		},
		[key],
	);

	return [state, setStateCallback];
};
